import { Config } from 'config/envConfig';
//settingsContainer.jsx
import React, { useRef } from 'react';
import { Container, NoInteractionView } from '@quyva/shared-ui';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { SettingsContent } from './settingsContent';
import { useSettingsContext } from '../../context';

export const SettingsContainer = ({
    accountSettingsRef,
    generalSettingsRef,
    activeSection,
    setActiveSection,
    organizationSettingsRef,
    organizationManagementRef,
    promptSettingsRef,
    systemSettingsRef,
    maintenanceRef,
    isAdmin,
}) => {
    const rootRef = useRef(null);
    const {
        isLoading,
        accountDetails,
        setAccountDetails,
        historyCounts,
        setHistoryCounts,
        organizationId,
        organizationName,
        organizationAddress,
        organizationIndustry,
        organizationWebsite,
        organizationOwner,
        userRole,
        setOrganizationName,
        setOrganizationAddress,
        setOrganizationIndustry,
        setOrganizationWebsite,
        setOrganizationOwner,
        setUserRole,
        fetchOrganizationDetails,
        orgQueryLimit,
        setOrgQueryLimit,
        isPostpaid,
        refine,
        setRefine,
    } = useSettingsContext();

    if (isLoading) {
        return <NoInteractionView viewText={'Loading ...'} />;
    }

    return (
        <SettingsContent
            activeSection={activeSection}
            accountDetails={accountDetails}
            setAccountDetails={setAccountDetails}
            refine={refine}
            onRefineChange={(checked) => setRefine(checked)}
            accountSettingsRef={accountSettingsRef}
            generalSettingsRef={generalSettingsRef}
            organizationSettingsRef={organizationSettingsRef}
            organizationManagementRef={organizationManagementRef}
            promptSettingsRef={promptSettingsRef}
            maintenanceRef={maintenanceRef}
            setActiveSection={setActiveSection}
            historyCounts={historyCounts}
            setHistoryCounts={setHistoryCounts}
            isAdmin={isAdmin}
            rootRef={rootRef}
            organizationId={organizationId}
            organizationName={organizationName}
            organizationAddress={organizationAddress}
            organizationIndustry={organizationIndustry}
            organizationWebsite={organizationWebsite}
            organizationOwner={organizationOwner}
            userRole={userRole}
            fetchOrganizationDetails={fetchOrganizationDetails}
            setOrganizationName={setOrganizationName}
            setOrganizationAddress={setOrganizationAddress}
            setOrganizationIndustry={setOrganizationIndustry}
            setOrganizationWebsite={setOrganizationWebsite}
            setOrganizationOwner={setOrganizationOwner}
            setUserRole={setUserRole}
            orgQueryLimit={orgQueryLimit}
            setOrgQueryLimit={setOrgQueryLimit}
            isPostpaid={isPostpaid}
        />
    );
};
